var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Grid", {
        ref: "grid",
        attrs: {
          service: _vm.service,
          route_name: "due-diligence-form",
          route_grid_path: "due-diligence/grid",
          order_column: "created_at",
          direction: "desc"
        },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function(actions) {
              return [
                _c(
                  "div",
                  { staticClass: "flex flex-row gap-2" },
                  [
                    _vm.hasReportUrl(actions.row)
                      ? _c("feather-icon", {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: "due_diligence_form.download.pdf",
                              expression: "'due_diligence_form.download.pdf'"
                            },
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.top",
                              value: {
                                content: "Baixar PDF",
                                delay: { show: 100, hide: 100 }
                              },
                              expression:
                                "{\n            content: 'Baixar PDF',\n            delay: { show: 100, hide: 100 }\n          }",
                              modifiers: { top: true }
                            }
                          ],
                          staticClass:
                            "h-5 w-5 mb-1 mr-1 stroke-current text-green",
                          attrs: { icon: "DownloadIcon" },
                          on: {
                            click: function($event) {
                              return _vm.downloadPDF(actions.row)
                            }
                          }
                        })
                      : _vm._e(),
                    actions.row && !_vm.hasReportUrl(actions.row)
                      ? _c("feather-icon", {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: "due_diligence_form.process_pdf",
                              expression: "'due_diligence_form.process_pdf'"
                            },
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.top",
                              value: {
                                content: "Gerar PDF",
                                delay: { show: 100, hide: 100 }
                              },
                              expression:
                                "{\n              content: 'Gerar PDF',\n              delay: { show: 100, hide: 100 }\n            }",
                              modifiers: { top: true }
                            }
                          ],
                          staticClass:
                            "h-5 w-5 mb-1 mr-1 stroke-current text-green",
                          attrs: { icon: "CheckIcon" },
                          on: {
                            click: function($event) {
                              return _vm.gerarPDF(actions.row.id)
                            }
                          }
                        })
                      : _vm._e(),
                    _vm.hasReportUrl(actions.row)
                      ? _c("feather-icon", {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: "due_diligence_form.reprocess_pdf",
                              expression: "'due_diligence_form.reprocess_pdf'"
                            },
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.top",
                              value: {
                                content: "Gerar PDF Novamente",
                                delay: { show: 100, hide: 100 }
                              },
                              expression:
                                "{\n              content: 'Gerar PDF Novamente',\n              delay: { show: 100, hide: 100 }\n            }",
                              modifiers: { top: true }
                            }
                          ],
                          staticClass:
                            "h-5 w-5 mb-1 mr-1 stroke-current text-danger",
                          attrs: { icon: "CheckIcon" },
                          on: {
                            click: function($event) {
                              return _vm.reprocessPDF(actions.row.id)
                            }
                          }
                        })
                      : _vm._e(),
                    _c("feather-icon", {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: "due_diligence_form.show",
                          expression: "'due_diligence_form.show'"
                        },
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: {
                            content: "Detalhar formulário",
                            delay: { show: 100, hide: 100 }
                          },
                          expression:
                            "{\n            content: 'Detalhar formulário',\n            delay: { show: 100, hide: 100 }\n          }",
                          modifiers: { top: true }
                        }
                      ],
                      staticClass:
                        "h-5 w-5 mb-1 mr-1 stroke-current text-warning",
                      attrs: { icon: "EyeIcon" },
                      on: {
                        click: function($event) {
                          return _vm.detail(actions.row.id)
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }